
import { TokenClient } from 'urbnTokenLib';

import { LoginUtility, ProfileClient } from './loginUtility/loginUtility';
import { log, debug, error } from './utils/logger';

export default class LoginScreen {
    constructor(siteId, tokenServiceBaseURL, profileServiceBaseURL) {
        const tokenClient = new TokenClient(siteId, tokenServiceBaseURL);
        const profileClient = new ProfileClient(siteId, profileServiceBaseURL);

        this.loginUtility = new LoginUtility(tokenClient, profileClient);
        this.attachEvents();
    }

    attachEvents() {
        const formElements = $('#loginForm');

        if (formElements) {
            const formElement = formElements[0];
            const thisInstance = this;

            formElement.addEventListener('submit', (event) => {
                event.preventDefault();

                const formData = {
                    emailAddress: $('#loginUsername')[0].value,
                    password: $('#loginPassword')[0].value
                };

                thisInstance.loginUtility.signIn(formData.emailAddress, formData.password)
                    .then((tokenSession) => {
                        log('login successful');
                        const originURL = thisInstance.getOriginQueryParam(window.location.search);

                        if (originURL) {
                            window.location = originURL;
                        } else {
                            window.location = '/';
                        }
                    })
                    .catch((err) => {
                        error(`Could not sign in: ${err}`);
                    });

                return false;
            });
        }
    }

    getOriginQueryParam(rawQueryString, originParam = 'url') {
        debug(`raw query string = ${rawQueryString}`);
        let queryString = rawQueryString;

        // ignore potential leading '?' in query string
        if (queryString.startsWith('?')) {
            queryString = queryString.slice(1);
        }

        debug(`query string = ${queryString}`);

        const originNameValuePair = queryString.split('&').map((fragment, index, arr) => {
                                        return fragment.split('=');
                                    }).filter((nameValuePair, index, arr) => {
                                        if (originParam === nameValuePair[0]) {
                                            return true;
                                        }

                                        return false;
                                    });

        debug(`originNameValuePair length = ${originNameValuePair.length}`);

        if (originNameValuePair && originNameValuePair.length > 0) {
            debug(`origin name: ${originNameValuePair[0][0]}, value: ${originNameValuePair[0][1]}`);
            return originNameValuePair[0][1];
        }

        debug('returning undefined');

        return undefined;
    }
};
